var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defaultRendererConfig, setupBingAerialImagery } from "./index";
import { repeat } from "../framework/utils";
import { Runner } from "../framework/Runner";
import { AnimationTrack } from "../framework/AnimationTrack";
import { MoveAnimator } from "../framework/MoveAnimator";
import { WaitAnimator } from "../framework/WaitAnimator";
import { PointCloudStyle } from "../../api";
import { Cartographic, Ellipsoid } from "../../private/math";
import { Vector3 } from "three";
import { EventAnimator } from "../framework/EventAnimator";
const GRADIENT_LONG = 2.6336649347873795;
const GRADIENT_LAT = -0.6015079820834716;
const GRADIENT_MIN = new Cartographic(GRADIENT_LONG, GRADIENT_LAT, 1);
const GRADIENT_MID = new Cartographic(GRADIENT_LONG, GRADIENT_LAT, 2);
const GRADIENT_MAX = new Cartographic(GRADIENT_LONG, GRADIENT_LAT, 3);
const STYLE = {
    pointStyle: PointCloudStyle.None,
    pointSize: 5,
};
export function tilesetClipping1(container, description) {
    return __awaiter(this, void 0, void 0, function* () {
        description.innerHTML =
            "<h1>" +
                "Tileset Clipping 1" +
                "</h1>" +
                "<p>" +
                "This will test clipping a tileset against clipping planes. The tileset should be clipped by a single plane." +
                "The clipping plane should remain stable during the whole test, only the tileset will move." +
                "</p>";
        const durations = repeat([2, 2], 3);
        const positions = repeat([
            [0, 0, 0],
            [0, 0, -1],
        ], 3);
        yield Runner.run(defaultRendererConfig(container), (renderer, camera) => __awaiter(this, void 0, void 0, function* () {
            // Scene setup
            setupBingAerialImagery(renderer);
            const group = renderer.createClippingGroup();
            group.planes.push({
                position: Ellipsoid.WGS_84.cartesianForCartographic(GRADIENT_MID),
                normal: {
                    x: 0,
                    y: 0,
                    z: -1,
                },
            });
            group.setEnabled(true);
            const object = yield renderer.getObjectFactory().createTileset({
                type: "direct",
                url: "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/models/UAV_UNT/tileset.json",
                style: STYLE,
            });
            group.addObject(object);
            renderer.getWorld().addObject(object);
            group.resolvePlanes();
            // Setup camera position
            camera.setPositionCartographic({
                longitude: 2.6336666462878293,
                latitude: -0.6015052766609263,
                height: 4.2652886109551895,
            });
            const up = new Vector3();
            Ellipsoid.WGS_84.rotationBasisForCartographic(Cartographic.fromApi(camera.getPositionCartographic()), null, up);
            camera.setUpVector(up);
            camera.lookAt({ x: -4599507.187343626, y: 2560383.6341716894, z: -3589262.8513382045 });
            const numSteps = Math.min(positions.length, durations.length);
            const pTrack = new AnimationTrack();
            for (let i = 0; i < numSteps - 1; i += 1) {
                pTrack.add(durations[i + 1], (beginTime, endTime) => {
                    return MoveAnimator.between(beginTime, endTime, object, {
                        start: positions[i],
                        end: positions[i + 1],
                    });
                });
                pTrack.add(4, WaitAnimator.between);
                pTrack.add(0.1, (beginTime, endTime) => EventAnimator.at(beginTime, endTime, () => {
                    object.applyStyle(STYLE);
                }));
                pTrack.add(4, WaitAnimator.between);
            }
            // Output the tracks
            return [pTrack];
        }));
    });
}
